import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {httpDeleteProjectSuspension} from '@/features/projects/http/projects.http'

export const useDeleteProjectSuspension = (
    projectId: string,
    suspensionId: string,
    options?: Omit<UseMutationOptions, 'mutationFn'>
) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.DELETE_PROJECT_SUSPENSION],
        mutationFn: () => httpDeleteProjectSuspension({urlParams: {projectId, suspensionId}}),
        ...options,
        // Removing a suspension changes the project status: the project lookups of the medical record
        // report flow must not keep answering with the suspended snapshot.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS_BY_PATIENT]})
            options?.onSuccess?.(data, variables, context)
        }
    })
